import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ImportSettingsTab() {
  const { can } = useAuth();
  const [v, setV] = useState("");
  const [cur, setCur] = useState(null);
  const edit = can("ayarlar", "edit");
  useEffect(() => { api.get("/settings/imports").then(({ data }) => { setCur(data); setV(data.delay_alert_days); }); }, []);
  const save = async () => {
    try { const { data } = await api.put("/settings/imports", { delay_alert_days: Number(v) }); setCur(data); toast.success("Gecikme eşiği güncellendi"); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (!cur) return <div className="panel h-32 animate-pulse" />;
  return (
    <div className="panel p-4 max-w-xl" data-testid="import-settings-tab">
      <h3 className="text-base font-semibold text-slate-800">Gecikme Uyarısı</h3>
      <p className="text-xs text-slate-500 mb-3">Güncel ETA, ilk ETA'dan bu kadar günden fazla kayarsa yönetici ve ithalat yetkililerine uygulama içi bildirim + anlık bildirim gider. Sonraki uyarı ancak ETA son uyarılan ETA'dan en az bu kadar daha kayarsa gönderilir.</p>
      <div className="flex items-center gap-2">
        <Input type="number" min="1" max="60" className="w-24 h-9" value={v} onChange={(e) => setV(e.target.value)} disabled={!edit} data-testid="delay-threshold-input" />
        <span className="text-sm text-slate-600">gün</span>
        {edit && <Button size="sm" className="bg-blue-600 hover:bg-blue-700" onClick={save} disabled={String(v) === String(cur.delay_alert_days)} data-testid="delay-threshold-save">Kaydet</Button>}
      </div>
    </div>
  );
}
